export const yAxisTickStyle = (isDark: boolean) => {
	return {
		fontSize: 12,
		fill: isDark ? '#FFF' : 'initial',
	};
};
